'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var WINDOW_ROUTE_CHANGE = 'window:route-change:event';
var WINDOW_BEFORE_UNLOAD = 'window:before-unload:event';
var IS_MOBILE_APP_QUERY = 'is-mobile-app:query';

exports.IS_MOBILE_APP_QUERY = IS_MOBILE_APP_QUERY;
exports.WINDOW_BEFORE_UNLOAD = WINDOW_BEFORE_UNLOAD;
exports.WINDOW_ROUTE_CHANGE = WINDOW_ROUTE_CHANGE;
